module.exports = __webpack_public_path__ + "img/img-37.44feed0c.png";